/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinktitle2Inputs */

const en_profilelinktitle2 = /** @type {(inputs: Profilelinktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect a Pulsify profile`)
};

const de_profilelinktitle2 = /** @type {(inputs: Profilelinktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify-Profil verbinden`)
};

/**
* | output |
* | --- |
* | "Connect a Pulsify profile" |
*
* @param {Profilelinktitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinktitle2 = /** @type {((inputs?: Profilelinktitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinktitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinktitle2(inputs)
	return de_profilelinktitle2(inputs)
});
export { profilelinktitle2 as "profileLinkTitle" }